import { useParams } from '@tanstack/react-router'
import { LogisticsPipelineWorkView } from '../components/LogisticsPipelineWorkView'

/**
 * Full-page per-pipeline-row working view. Thin wrapper reading
 * `pipelineId` from the route param.
 */
export function LogisticsPipelinePage() {
  const params = useParams({ strict: false }) as { pipelineId?: string }
  const pipelineId = params.pipelineId
  if (!pipelineId) {
    return <div className="p-8 text-tertiary">Invalid pipeline id.</div>
  }
  return <LogisticsPipelineWorkView pipelineId={pipelineId} />
}
